<!--
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-07-15 11:35:34
 * @LastEditTime: 2022-03-16 10:54:51
 * @LastEditors: chenguobiao
-->
<template>
  <div class="chess-question">
    <question-desc :desc="question.topic" :questionType="questionType" :key="question.uid" :score="question.score"></question-desc>
    <template v-if="questionType === 'national_iconic'">
      <div class="chess-question__national_iconic flex justfy-center">
        <chess-board
          ref="chessRef"
          :roomId="roomId"
          :free="free"
          :disabled="disabled"
          :fen="question.fen"
          @captured="onCaptured"
          @move="onMove"
          @over="onGameOver"
        />
        <replay-detail :question="question"  v-if="replay"/>
      </div>
    </template>
    <template v-else>
      <div class="chess-question__ai flex justify-center">
        <player-detail ref="playerRef" :aiUserInfo="aiUserInfo" :manUserInfo="manUserInfo" :captures="captures" :turn="turn" @manTimeOver="timeOver" />
        <chess-board
          ref="chessRef"
          :roomId="roomId"
          :free="true"
          :disabled="disabled"
          :fen="question.fen"
          @captured="onCaptured"
          @move="onMove"
          @over="onGameOver"
        />
        <answer-detail :questionType="questionType" :pgn="pgnList"/>
      </div>
    </template>
    <!-- 棋子升变 -->
    <promotion ref="promotionRef" :visible="promotionVisible" :turn="turn" />
  </div>
</template>

<script>
import store from 'store'
import ChessBoard from '@/render/components/chess-board'
import { WS_GAME_CONFIGS, USER_INFO } from '@/config/const'
import QuestionDesc from './QuestionDesc'
import Promotion from './Promotion'
import AnswerDetail from './AnswerDetail'
import ReplayDetail from './ReplayDetail'
import PlayerDetail from './PlayerDetail'
export default {
  inject: ['timeOver'],
  props: ['questionType', 'question', 'pauseFlag'],
  data() {
    return {
      roomId: null,
      replay: false,
      free: false,
      GAME_STATUS: null,
      promotionVisible: false,
      captures: {},
      aiUserInfo: null,
      manUserInfo: null,
      pgnList: []
    }
  },
  computed: {
    disabled() {
      return this.GAME_STATUS === 'end' || (this.pauseFlag ? false : this.replay)
    },
  },
  components: {
    ChessBoard,
    QuestionDesc,
    Promotion,
    AnswerDetail,
    ReplayDetail,
    PlayerDetail
  },
  created() {
    this.turn = store.get(WS_GAME_CONFIGS).player_turn
    this.replay = store.get(WS_GAME_CONFIGS).replay
    this.initUserInfo()
  },
  mounted() {
    const { roomId } = this.configs
    this.roomId = roomId
  },
  methods: {
    initUserInfo() {
      const { type, compete_level } = this.configs
      const userInfo = store.get(USER_INFO)
      userInfo.avatar = require('@/render/assets/images/grading/man.png')
      this.manUserInfo = userInfo

      switch (type) {
        default:
          this.aiUserInfo = {
            name: `智能机器人`,
            scoreAi: compete_level,
            avatar: require('@/render/assets/images/grading/ai.png'),
            isAi: true
          }
          break
      }
    },
    // 吃子
    onCaptured(captures) {
      this.captures = captures
    },
    // 升变
    onPromotion() {
      return new Promise((resolve, reject) => {
        this.promotionVisible = true

        this.$refs.promotionRef.onOk = () => {
          const selected = this.$refs.promotionRef.selected
          this.promotionVisible = false
          resolve(selected)
        }
      })
    },
    onMove() {
      const { chessRef } = this.$refs
      const { game } = chessRef
      let history = game.history()
      let verboseHistory = game.history({ verbose: true })
      if (verboseHistory[0] && verboseHistory[0].color === 'b') history.unshift('...');
      let len = Math.ceil(history.length / 2)
      let pgnList = []
      for (let i = 0; i < len; i++) {
        pgnList.push({
          step: i + 1 + '.',
          from: history[i * 2],
          to: history[i * 2 + 1]
        })
      }
      this.pgnList = pgnList
      this.turn = game.turn()
    },
    onGameOver(params) {
      this.$emit('gameOver', params)
    }
  },
}
</script>

<style lang="scss" scoped>
  .chess-question {
    &__national_iconic,
    &__ai {
      position: relative;
      ::v-deep {
        .replay-detail {
          position: absolute;
          right: val(-56);
          transform: translateX(100%);
        }
      }
    }
    &__ai {
      padding-top: val(16);
    }
  }
</style>
